import { render, staticRenderFns } from "./fm_registration.vue?vue&type=template&id=b1bf0c6a&"
import script from "./fm_registration.vue?vue&type=script&lang=js&"
export * from "./fm_registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports